export const STAFF_EMAIL_DOMAINS = ['lwegatech.com', 'lwegatech.info'] as const

export function isAllowedStaffEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase()
  const atIndex = normalized.lastIndexOf('@')

  if (atIndex <= 0 || atIndex === normalized.length - 1) {
    return false
  }

  const domain = normalized.slice(atIndex + 1)
  return STAFF_EMAIL_DOMAINS.includes(domain as (typeof STAFF_EMAIL_DOMAINS)[number])
}

